// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Footer_buttonsContainer__9MP0G","save":"Footer_save__eyBrc","cancel":"Footer_cancel__oFJls"};